<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <div class="box box-primary">
                    <div class="box-header with-border">
                        <h3 class="box-title">
                            <b>Solicitação</b>
                        </h3>
                    </div>
                    <div class="box-body">
                        <solicitacao-detalhes :show-info="showInfo" :solicitacao="solicitacao" @showModalNaoRealizados="showModalNaoRealizados = true"></solicitacao-detalhes>
                        <div class="box collapsed-box ">
                            <div class="box-header with-border">
                                <h3 class="box-title">Histórico da Solicitação</h3>
                                <div class="box-tools pull-right">
                                    <button type="button" class="btn btn-box-tool" data-widget="collapse">
                                        <i class="fa fa-plus"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="box-body altura-hostorico">
                                <solicitacao-historico :solicitacao="solicitacao"></solicitacao-historico>
                            </div>
                        </div>
                        <div class="box collapsed-box ">
                            <div class="box-header with-border">
                                <h3 class="box-title">Histórico do Paciente</h3>
                                <div class="box-tools pull-right">
                                    <button type="button" class="btn btn-box-tool" data-widget="collapse">
                                        <i class="fa fa-plus"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="box-body">
                                <label for="">Histórico do sistema novo</label>
                                <table class="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>Situação</th>
                                            <th>Unidade realizadora</th>
                                            <th>Data da realização</th>
                                            <th>Prof. Realizador</th>
                                            <th>Procedimento</th>
                                            <th>Solicitado em</th>
                                            <th>Unidade solicitante</th>
                                            <th>Prof. Solicitante</th>
                                            <th>Prof. Marcador</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="even" role="row" v-for="(item, index) in historico.data" :key="index">
                                            <td>{{ item.solicitacao.situacao | situacaoSolicitacao }}</td>
                                            <td>{{ item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.nome : item.contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.nome }}</td>
                                            <td>{{ item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.data_atendimento : item.contrato_subgrupo_atendimento.data_atendimento | dataFormatada }}</td>
                                            <td>{{ item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.profissional.nome : "SEM PROFISSIONAL" }}</td>
                                            <td>{{ item.contrato_procedimento.procedimento.nome }}</td>
                                            <td>{{ item.solicitacao.created_at | dataFormatada }}</td>
                                            <td>{{ item.contrato_procedimento.contrato.unidade.nome }}</td>
                                            <td>{{ item.solicitacao.profissional.nome }}</td>
                                            <td>{{ item.solicitacao.usuario.name }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <br />
                                <div class="row">
                                    <div class="col-sm-5">Mostrando {{ this.historico.from }} até {{ this.historico.to }} de {{ this.historico.total }} registros encontrados.</div>
                                    <div class="col-sm-7" style="text-align:right">
                                        <laravue-pagination :limit="7" :data="historico" v-on:pagination-change-page="getHistorico">
                                            <span slot="prev-nav">&lt; Anterior</span>
                                            <span slot="next-nav">Próximo &gt;</span>
                                        </laravue-pagination>
                                    </div>
                                </div>
                                <br />
                                <label for="">Histórico do sistema antigo</label>
                                <table class="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>Situação</th>
                                            <th>Unidade realizadora</th>
                                            <th>Data da realização</th>
                                            <th>Prof. Realizador</th>
                                            <th>Procedimento</th>
                                            <th>Solicitado em</th>
                                            <th>Unidade solicitante</th>
                                            <th>Prof. Solicitante</th>
                                            <th>Prof. Marcador</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="even" role="row" v-for="(item, index) in historicoAntigo.data" :key="index">
                                            <td>{{ item.situacao | situacaoSolicitacaoAntiga }}</td>
                                            <td>{{ item.unidade_realizadora }}</td>
                                            <td>{{ item.data_realizacao | dataFormatada }}</td>
                                            <td>{{ item.profissional_realizador }}</td>
                                            <td>{{ item.procedimento }}</td>
                                            <td>{{ item.data_solicitacao | dataFormatada }}</td>
                                            <td>{{ item.unidade_solicitante }}</td>
                                            <td>{{ item.profissional_solicitante }}</td>
                                            <td>{{ item.profissional_marcador }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <br />
                                <div class="row">
                                    <div class="col-sm-5">Mostrando {{ this.historicoAntigo.from }} até {{ this.historicoAntigo.to }} de {{ this.historicoAntigo.total }} registros encontrados.</div>
                                    <div class="col-sm-7" style="text-align:right">
                                        <laravue-pagination :limit="7" :data="historicoAntigo" v-on:pagination-change-page="getHistoricoAntigo">
                                            <span slot="prev-nav">&lt; Anterior</span>
                                            <span slot="next-nav">Próximo &gt;</span>
                                        </laravue-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="box-footer">
                        <div class="row">
                            <div class="col-md-6">
                                <button class="btn btn-default pull-left" @click="$router.go(-1)"><i class="fa fa-reply"></i> Voltar</button>
                            </div>
                            <div v-if="solicitacao.situacao == SITUACAO_SOLICITACAO.EM_REGULACAO || solicitacao.situacao == SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL" class="col-md-6">
                                <div style="text-align:right">
                                    <button @click="informacaoPendente" class="btn btn-info"><i class="fa fa-comment"></i> Solicitar informação pendente</button>
                                    <button v-on:click="negativar" class="btn btn-danger"><i class="fa fa-times-circle"></i> Negativar</button>
                                    <button v-on:click="agendar" class="btn btn-primary"><i class="fa fa-calendar"></i> Atendimentos</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal-nao-realizados :regulacao="true" :nao-realizados="naoRealizados" :show="showModalNaoRealizados" @close="showModalNaoRealizados = false"></modal-nao-realizados>
    </section>
</template>

<script>
import axios from "axios"; // Cliente para requisição http
import solicitacaoDetalhes from "../comuns/solicitacaoDetalhes";
import modalNaoRealizados from "../comuns/modalNaoRealizados";
import solicitacaoHistorico from "../comuns/solicitacaoHistorico";
import { SITUACAO_SOLICITACAO } from "@/constants";

export default {
    components: { solicitacaoDetalhes, solicitacaoHistorico, modalNaoRealizados },
    data: () => ({
        showModalNaoRealizados: false,
        showInfo: false,
        naoRealizados: [],
        solicitacao: {
            created_at: "",
            id: "",
            itens: [
                {
                    contrato_procedimento: {
                        contrato: {
                            unidade: {
                                nome: ""
                            }
                        },
                        procedimento: {
                            nome: ""
                        }
                    },
                    contrato_procedimento_atendimento: {
                        profissional: {
                            nome: ""
                        }
                    }
                }
            ],
            paciente: "",
            paciente_id: "",
            profissional: "",
            profissional_solicitante_id: "",
            situacao: "",
            solicitacao_historicos: [],
            diagnosticos: [],
            updated_at: "",
            usuario: "",
            usuario_solicitante_id: ""
        },
        filtros: {
            pesquisa: "",
            coluna: null,
            ordem: null
        },
        dataTable: {},
        dados: { observacao: "" },
        historicoAntigo: {},
        historico: {}
    }),
    computed: {
        SITUACAO_SOLICITACAO: function() {
            return SITUACAO_SOLICITACAO;
        }
    },
    mounted() {
        this.solicitacaoId = this.$route.params.solicitacaoId;
        if (this.solicitacaoId) {
            this.boxTitle = "Regulação de Atendimentos";
            this.getSolicitacao(this.solicitacaoId);
        }
    },
    methods: {
        getNaoRealizados() {
            axios
                .get(`${this.$store.state.serverURI}/api/cadastros/pacientes/getNaoRealizados/` + this.solicitacao.paciente_id, this.$store.getters.getHeaderAuth)
                .then(response => {
                    this.naoRealizados = response.data;
                    if (this.naoRealizados.length > 0) {
                        this.showModalNaoRealizados = true;
                        this.showInfo = true;
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getSolicitacao(solicitacaoId) {
            axios
                .get(`${this.$store.state.serverURI}/api/atendimentos/getById/${this.solicitacaoId}`, this.$store.getters.getHeaderAuth)
                .then(response => {
                    this.solicitacao = response.data;
                    this.getHistorico();
                    this.getHistoricoAntigo();
                    this.getNaoRealizados();
                })
                .catch(error => {
                    console.log(error);
                });
        },
        negativar() {
            this.$swal({
                title: `Justificativa da negativa:`,
                type: "error",
                showCancelButton: true,
                input: "textarea",
                inputAttributes: { autocapitalize: "off" },
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true,
                inputValidator: value => {
                    return !value && "Insira a justificativa!";
                },
                preConfirm: observacao => {
                    this.dados.observacao = observacao;
                }
            }).then(result => {
				let loader = this.$loading.show()
                this.$store.commit("TOGGLE_LOADING");
                this.dados.solicitacaoId = this.solicitacaoId;
                if (result.value) {
                    axios
                        .post(`${this.$store.state.serverURI}/api/atendimentos/negativar`, this.dados, this.$store.getters.getHeaderAuth)
                        .then(response => {
							loader.hide()
                            this.$store.commit("TOGGLE_LOADING");
                            this.$swal({
                                type: "success",
                                title: "Solicitação negativada com sucesso!",
                                showConfirmButton: false,
                                timer: 1500
                            });
                            this.$router.go(-1);
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            });
        },
        informacaoPendente() {
            this.dados.situacao = this.SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE;
            this.$swal({
                title: `Mensagem para o marcador:`,
                type: "info",
                showCancelButton: true,
                input: "textarea",
                inputAttributes: { autocapitalize: "off" },
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-paper-plane"></i> Enviar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true,
                inputValidator: value => {
                    return !value && "Insira a mensagem!";
                },
                preConfirm: observacao => {
                    this.dados.observacao = observacao;
                }
            }).then(result => {
				let loader = this.$loading.show()
                this.$store.commit("TOGGLE_LOADING");
                this.dados.solicitacaoId = this.solicitacaoId;
                if (result.value) {
                    axios
                        .post(`${this.$store.state.serverURI}/api/atendimentos/atualizarSituacao`, this.dados, this.$store.getters.getHeaderAuth)
                        .then(response => {
							loader.hide();
                            this.$store.commit("TOGGLE_LOADING");
                            this.$swal({
                                type: "success",
                                title: "Mensagem enviada com sucesso!",
                                showConfirmButton: false,
                                timer: 1500
                            });
                            this.$router.go(-1);
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            });
        },
        agendar() {
            this.$router.push(`/atendimentos/solicitacao/resolucao/${this.solicitacaoId}`);
        },
        getHistorico(page) {
            if (typeof page === "undefined") {
                page = 1;
            }

            let config = this.$store.getters.getHeaderAuth;
            config.params = {
                page: page
            };

            axios
                .get(`${this.$store.state.serverURI}/api/cadastros/pacientes/getHistorico/` + this.solicitacao.paciente_id, config)
                .then(response => {
                    this.historico = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getHistoricoAntigo(page) {
            if (typeof page === "undefined") {
                page = 1;
            }

            let config = this.$store.getters.getHeaderAuth;
            config.params = {
                page: page
            };

            axios
                .get(`${this.$store.state.serverURI}/api/cadastros/pacientes/getHistoricoAntigo/` + this.solicitacao.paciente_id, config)
                .then(response => {
                    this.historicoAntigo = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        }
    },
    watch: {}
};
</script>



// WEBPACK FOOTER //
// solicitacao.vue?70a284da